import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VMenu, {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VRow, {
          attrs: {
            "align": "center",
            "data-cy": `${_vm.dataCy || 'template'}-activator-container`
          }
        }, [_c(VCol, {
          staticClass: "template-text-field-menu"
        }, [_c(VTextField, _vm._b({
          ref: "templateInput",
          attrs: {
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "label": _vm.label,
            "rules": _vm.rules,
            "required": _vm.required,
            "disabled": "",
            "hide-details": "",
            "data-cy": `${_vm.dataCy || 'template'}-activator-input`
          },
          model: {
            value: _vm.template,
            callback: function ($$v) {
              _vm.template = $$v;
            },
            expression: "template"
          }
        }, 'v-text-field', attrs, false))], 1), _c(VCol, {
          attrs: {
            "cols": "auto"
          }
        }, [_c(VBtn, {
          attrs: {
            "icon": "",
            "data-cy": `${_vm.dataCy || 'template'}-activator-button`
          },
          on: {
            "click": on.click
          }
        }, [_c(VIcon, [_vm._v("fal fa-pen")])], 1)], 1)], 1)];
      }
    }]),
    model: {
      value: _vm.showMenu,
      callback: function ($$v) {
        _vm.showMenu = $$v;
      },
      expression: "showMenu"
    }
  }, [_c(VCard, {
    attrs: {
      "data-cy": `${_vm.dataCy || 'template'}-dialog-container`
    }
  }, [_c(VCardText, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.label,
      "rules": _vm.rules,
      "required": _vm.required,
      "append-outer-icon": "fal fa-close",
      "data-cy": `${_vm.dataCy || 'template'}-dialog-container-template-input`
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      },
      "click:append-outer": function ($event) {
        _vm.showMenu = false;
      }
    },
    model: {
      value: _vm.template,
      callback: function ($$v) {
        _vm.template = $$v;
      },
      expression: "template"
    }
  }), _c(VTextField, {
    attrs: {
      "data-cy": `${_vm.dataCy || 'template'}-dialog-container-search-input`,
      "label": _vm.$t('Dashboards.components.templateTextField.searchForTemplateParameter'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-magnifying-glass",
      "hide-details": ""
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    },
    model: {
      value: _vm.searchForTemplateParameter,
      callback: function ($$v) {
        _vm.searchForTemplateParameter = $$v;
      },
      expression: "searchForTemplateParameter"
    }
  })], 1)], 1), _c(VList, {
    staticStyle: {
      "max-height": "calc(60vh - 10rem)",
      "overflow-y": "auto"
    },
    attrs: {
      "data-cy": `${_vm.dataCy || 'template'}-dialog-container-search-list`
    }
  }, _vm._l(_vm.filteredTwinFields, function (item, index) {
    return _c(VListItem, {
      key: index,
      on: {
        "click": function ($event) {
          return _vm.appendParameterToTemplate(item);
        }
      }
    }, [_c(VListItemTitle, [_vm._v(_vm._s(item.defaultLabel))])], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };